import { getMediaUploadUrl } from '@wix/ambassador-forms-v4-submission-http/http';
export const uploadFile = ({ httpClient: _httpClient, errorHandler })=>{
    return async ({ formId, file, uploadTarget })=>{
        async function uploadFileToMediaManager(uploadUrl, _file) {
            const params = {
                filename: _file.name
            };
            const headers = {
                'Content-Type': 'application/octet-stream'
            };
            try {
                const uploadResponse = await errorHandler.withErrorHandler(()=>_httpClient.put(uploadUrl, _file, {
                        headers,
                        params
                    }), {
                    errorCodesMap: {}
                });
                const fileDescriptor = {
                    id: uploadResponse.data.file?.id,
                    displayName: uploadResponse.data.file?.displayName,
                    url: uploadResponse.data.file?.url,
                    isPrivate: uploadResponse.data.file?.private ?? false
                };
                return fileDescriptor;
            } catch (e) {
                const resolvedError = errorHandler.getResolvedError(e);
                throw resolvedError;
            }
        }
        async function uploadFilesToMediaPlatform(uploadUrl, _file) {
            const params = {
                filename: _file.name
            };
            const headers = {
                'Content-Type': 'application/octet-stream'
            };
            try {
                const uploadResponse = await errorHandler.withErrorHandler(()=>_httpClient.put(uploadUrl, _file, {
                        headers,
                        params
                    }), {
                    errorCodesMap: {}
                });
                const fileDescriptor = {
                    id: uploadResponse.data.payload.id,
                    displayName: _file.name,
                    url: uploadResponse.data.payload.path,
                    isPrivate: uploadResponse.data.payload.acl !== 'public'
                };
                return fileDescriptor;
            } catch (e) {
                const resolvedError = errorHandler.getResolvedError(e);
                throw resolvedError;
            }
        }
        async function getUploadUrl(_file, _formId, _uploadTarget) {
            try {
                const { data } = await errorHandler.withErrorHandler(()=>_httpClient.request(getMediaUploadUrl({
                        // octet-stream is a generic binary file, we fallback to it in case we can't identify the file type
                        mimeType: _file.type || 'application/octet-stream',
                        formId,
                        filename: _file.name,
                        uploadTarget: _uploadTarget
                    })), {
                    errorCodesMap: {}
                });
                return {
                    uploadUrl: data.uploadUrl,
                    generatedByMediaPlatform: data.generatedByMediaPlatform
                };
            } catch (e) {
                const resolvedError = errorHandler.getResolvedError(e);
                throw resolvedError;
            }
        }
        const { uploadUrl, generatedByMediaPlatform } = await getUploadUrl(file, formId, uploadTarget);
        const descriptorWithFile = generatedByMediaPlatform ? await uploadFilesToMediaPlatform(uploadUrl, file) : await uploadFileToMediaManager(uploadUrl, file);
        return descriptorWithFile;
    };
};

//# sourceMappingURL=upload-file.js.map